// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UploadDocumentModal_buttons__3XNj4"};